/* eslint-disable react/forbid-prop-types */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { apiGetModel } from '../../../useApiHook';
import { callAxios } from '../../../../services/callAPIMiddleware';

export const useFetchActivities = (params, forceReload) => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [state, setState] = useState({ response: null, refresh: forceReload });
  const [error, setError] = useState(null);
  const [isTableDataLoading, setIsTableDataLoading] = useState(true);

  // Prepare api model and request call
  const getModel = apiGetModel('GetActivities', params, forceReload);
  const setRequestResponse = response => {
    setState({ ...state, response, isDataLoading: false, refresh: forceReload });
    setIsTableDataLoading(false);
  };

  useEffect(() => {
    if (jwtToken) {
      setIsTableDataLoading(true);
      callAxios(auth, getModel.url, getModel.method, getModel.data)
        .then(result => {
          setRequestResponse(result.data);
          setIsDataLoading(false);
        })
        .catch(ex => {
          setError(ex.mesage);
          setIsTableDataLoading(false);
        });
    }
  }, [jwtToken, getModel.url, getModel.reloadData]);

  // Returning strongly-type mappedDto object

  if (state.response === null) {
    state.response = [];
  } else {
    state.response.mappedActivities = state.response.activities.map(a => {
      return {
        id: a.activityId,
        description: a.name,
        activityTypeId: a.activityType.id,
        activityTypeName: a.activityType.name,
        ragId: a.ragStatus.id,
        ragName: a.ragStatus.name,
        requiredClinicians: a.requiredClinicians,
        duration: a.duration,
        timeAverage: a.timeAverage,
        bandId: a.band.id,
        bandName: a.band.name,
        skillIds: a.skills.map(s => s.id),
        varianceFactors: a.activityVariancesFactors,
        status: a.isActive,
        isAssigned: a.isAssigned,
        externalCode: a.externalCode,
        orgUnitIds: a.orgUnits.map(o => o.id),
        orgUnitsNames: a.orgUnits.map(o => o.name).join(', '),
      };
    });
  }

  return {
    data: state.response,
    isDataLoading,
    auth,
    error,
    isTableDataLoading,
  };
};

export const useFetchBandOptions = forceReload => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [state, setState] = useState({ response: null, isDataLoading: true, refresh: forceReload });
  const [error, setError] = useState(null);

  // Prepare api model and request call
  const getModel = apiGetModel('GetBandsOptions', forceReload);
  const setRequestResponse = response => setState({ ...state, response, isDataLoading: false, refresh: forceReload });

  useEffect(() => {
    if (jwtToken) {
      callAxios(auth, getModel.url, getModel.method, getModel.data)
        .then(result => setRequestResponse(result.data))
        .catch(ex => {
          setError(ex.mesage);
          setState({ ...state, isDataLoading: false });
        });
    }
  }, [jwtToken, getModel.url, getModel.reloadData]);

  // Returning strongly-type mappedDto object
  return {
    data: state.response ? state.response.options : [],
    isDataLoading: state.isDataLoading,
    auth,
    error,
  };
};

export const useFetchSkillsOptions = forceReload => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [state, setState] = useState({ response: null, isDataLoading: true, refresh: forceReload });
  const [error, setError] = useState(null);

  // Prepare api model and request call
  const getModel = apiGetModel('GetSkillsOptions', forceReload);
  const setRequestResponse = response => setState({ ...state, response, isDataLoading: false, refresh: forceReload });

  useEffect(() => {
    if (jwtToken) {
      callAxios(auth, getModel.url, getModel.method, getModel.data)
        .then(result => setRequestResponse(result.data))
        .catch(ex => {
          setError(ex.mesage);
          setState({ ...state, isDataLoading: false });
        });
    }
  }, [jwtToken, getModel.url, getModel.reloadData]);

  // Returning strongly-type mappedDto object
  return {
    data: state.response ? state.response.options : [],
    isDataLoading: state.isDataLoading,
    auth,
    error,
  };
};

export const useFetchActivityVarianceOptions = (activityId, forceReload) => {
  const auth = useSelector(state => state.global.auth);
  const jwtToken = auth.jwtToken;
  const [state, setState] = useState({ response: null, isDataLoading: true, refresh: forceReload });
  const [error, setError] = useState(null);

  // Prepare api model and request call
  const getModel = apiGetModel('GetActivityVarianceIntervals', { activityId }, forceReload);
  const setRequestResponse = response => setState({ ...state, response, isDataLoading: false, refresh: forceReload });

  useEffect(() => {
    if (jwtToken) {
      callAxios(auth, getModel.url, getModel.method, getModel.data)
        .then(result => setRequestResponse(result.data))
        .catch(ex => {
          setError(ex.mesage);
          setState({ ...state, isDataLoading: false });
        });
    }
  }, [jwtToken, getModel.url, getModel.reloadData]);

  // Returning strongly-type mappedDto object
  return {
    data: state.response ? state.response.options : [],
    isDataLoading: state.isDataLoading,
    auth,
    error,
  };
};
